import Parse from "/server/parse-server.js";
import locationId from "/server/parse-location.js";
import { LocationObject } from "/server/parse-location.js";
import { goToNextPage } from "/reusable/navigation.js";
import { formatPhoneNumber } from "/reusable/string.js";
import { formatPhone } from "/reusable/string.js";
import analytics from "/firebase-analytics/analytics.js";
import { logEvent } from "firebase/analytics";
import { getFunnel, generateEventId } from "/reusable/analytic-ids.js";
import { getMetaCookies } from "/reusable/facebook-client-utils.js";
import { hashString, hashPhone } from "/reusable/cryptos.js";

"use strict";
window.Webflow ||= [];
window.Webflow.push(async () => { 

    // MARK - DEFINE ELEMENTS
    const currentUser = Parse.User.current();
    if (currentUser != null && currentUser.get('anonymous') == false) {
        goToNextPage('/');
    }

    const progressModal = document.getElementById('progressModal');

    const topLabel = document.getElementById('topLabel');

    const firstNameField = document.getElementById("createAccountFirstNameField");
    const lastNameField = document.getElementById("createAccountLastNameField"); 
    const phoneField = document.getElementById("createAccountPhoneTextField");
    const emailFIeld = document.getElementById("createAccountEmailFIeld");
    const passwordField = document.getElementById("createAccountPasswordField");
    const confirmPasswordField = document.getElementById("createAccountConfirmPasswordField");
    const referralTextField = document.getElementById('referralTextField');

    const referValidImageView = document.getElementById('referValidImageView');

    const checkBox = document.getElementById("createAccountCheckBox");

    const createAccountFormButton = document.getElementById("createAccountFormButton");

    // MARK: - REFERRAL / OFFER
    var referralid;
    var initialoffer;
    var initialamount;

    const locationObject = await LocationObject();

    const referid = sessionStorage.getItem('referid');
    if (referid != null) {
        referralTextField.value = referid;
        referralid = referid;
        initialoffer = null;
        await loadRefferalUser(referid);
    }

    async function loadRefferalUser(referid) {
        const user = await Parse.Cloud.run('loadUser', {"userid": referid});
        const firstname = user.get('firstname');
        referralid = user.id;
        initialamount = locationObject.get('initialreferdiscount');
        topLabel.innerText = 'EARN REFERRAL OFFER FROM YOUR FRIEND ' + firstname.toUpperCase();
        referValidImageView.style.display = 'block';
    }

    /*
    const initial = sessionStorage.getItem('initialoffer');
	if (initial != null) {
        referralid = null;
        initialoffer = initial;
		initialamount = locationObject.get('initialamount');
        referralTextField.value = 'Welcome' + initialamount;
        topLabel.innerText = 'EARN WELCOME ' + initialamount + '% OFFER';
        referralTextField.disabled = true;
	}*/

    const offer = sessionStorage.getItem('offer');
    if (offer != null) {
        referralTextField.value = offer.toUpperCase();
        if (offer == "Welcome15") {
            referralid = null;
            initialoffer = offer;
		    initialamount = 15;
            referralTextField.value = 'Welcome' + initialamount;
            topLabel.innerText = 'EARN WELCOME ' + initialamount + '% OFFER';
            referralTextField.disabled = true;
        }
        if (offer == "freepizza") {
            referralid = null;
            initialoffer = null;
            topLabel.innerText = 'CLAIM YOUR FREE PIZZA';
            referralTextField.disabled = true;
        }
    }

    // MARK: - DISABLE FORM
    $("#createAccountForm").submit(() => { return false; });

    // MARK: - PHONE INPUT
    phoneField.addEventListener('keydown', () => {
        const formattedValue = formatPhoneNumber(phoneField);
        phoneField.value = formattedValue;
    });

    phoneField.addEventListener('input', (e) => {
        const phone = phoneField.value;
        if (phone.length > 14) { phoneField.value = phone.substring(0, 14); }
    });

    referralTextField.addEventListener('input', async (e) => {
        const referralId = referralTextField.value;
        if (referralId.length > 10) { referralTextField.value = referralId.substring(0, 10); }
        await updateReferInput(referralId);
    });

    async function updateReferInput(referid) {
        if (referid.length == 10) {
            await loadRefferalUser(referid);
        } else {
            referralid = null;
            initialoffer = null;
            referValidImageView.style.display = 'none';
            topLabel.innerText = 'JOIN TO EARN FREE REWARDS AND CHECK OUT FASTER';
        }
    }

    // MARK: - BUTTON ACTIONS
    createAccountFormButton.addEventListener('click', async () => {
        const firstName = firstNameField.value;
        const lastName = lastNameField.value;
        const phone = phoneField.value.replace(/\D/g, '');
        const email = emailFIeld.value;
        const password = passwordField.value;
        const confirmPassword = confirmPasswordField.value;
        const error = verifyCreateAccountInfo(firstName, lastName, phone, email, password, confirmPassword);
        if (error != '') {
            alert(error);
        } else {
            createAccount(firstName, lastName, phone, email, password);
        }
    });

    // MARK: - CREATE ACCOUNT
    function verifyCreateAccountInfo(firstName, lastName, phone, email, password, confirmPassword) {
        var error = '';
        if (password != confirmPassword) { error = 'Passwords do not match'; }
        if (password.length <= 6) { error = 'Password must contain more than 6 characters'; }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (!emailRegex.test(email)) { error = 'Enter a valid email addres'; }
        if (phone.length != 10) { error = '10 digit phone is required'; }
        if (lastName == '') { error = 'Last name is required'; }
        if (firstName == '') { error = 'First name is required'; }
        return error;
    }

    async function createAccount(firstName, lastName, phone, email, password) {

        var device = "web";
        if (window.AndroidApp) {
            device = "android";
        }

        const funnel = getFunnel();

        const joinComs = checkBox.checked;
        const userData = {'firstName':firstName,'lastName':lastName,'phoneNumber':phone,'email':email,'password':password, 'joinComs': joinComs, 'locationid': locationId, "device": device, "funnel": funnel};

        progressModal.style.display = 'flex';

        try {
            const newUser = await Parse.Cloud.run('createUserAccount', userData);
            const sessionToken = newUser.get('sessionToken');
            await Parse.User.become(sessionToken);

            if (window.AndroidApp && window.AndroidApp.setUserId) {
                AndroidApp.setUserId(newUser.id); 
            }

            //signUpAnalytics(newUser);
            
            if (offer != null) {
                if (offer == "freepizza") {
                    goToNextPage("/free-pizza");
                } 
                if (offer == "Welcome15") {
                    goToNextPage("/download-app");
                }
            } else {
                goToNextPage('/profile');
            }
            /*
            if (referralid != null || initialoffer != null) {
                setUpPhoneVerify(phone);
            } else {
                goToNextPage('/profile');
            }*/
        } catch (e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }

    async function signUpAnalytics(newUser) {

        logEvent(analytics, 'sign_up', {method: 'Email'});

        const funnel = getFunnel();
        const eventId = generateEventId();

        const hashedFN = await hashString(newUser.get("firstname"));
        const hashedLN = await hashString(newUser.get("lastname"));
        const hashedEmail = await hashString(newUser.get("email"));
        const hashedPhone = await hashPhone(newUser.get("phonenumber"));
        const hashedId = await hashString(newUser.id);

        fbq('track', 'CompleteRegistration', {
            funnel_id: funnel.funnelId,
            utm_campaign: funnel.utm_campaign,
            fbclid: funnel.fbclid,
            registration_method: 'Email',
            platform: 'website',
            fn: hashedFN ?? undefined,
            ln: hashedLN ?? undefined,
            em: hashedEmail ?? undefined,
            ph: hashedPhone ?? undefined,
            external_id: hashedId ?? undefined,
        }, {eventID: eventId});
        
        const { fbp, fbc, userAgent } = getMetaCookies();
        const customData = {
            registration_method: 'Email',
            platform: 'website'
        }

        const userData = {userAgent: userAgent, fbp: fbp, fbc: fbc}
        const request = {
            customData: customData,
            userData: userData,
            funnel: funnel,
            eventId: eventId
        }
        await Parse.Cloud.run('fbCompleteRegister', request);
    }

    // MARK: - VERIFY PHONE
    const verifyModal = document.getElementById('verifyModal');
    const verifyTopLabel = document.getElementById('verifyTopLabel');
    const verifyPhoneTextField = document.getElementById('verifyPhoneTextField');
    const resendCodeButton = document.getElementById('resendCodeButton');
    const verifySmsButton = document.getElementById('verifySmsButton');
    const closeVerifyButton = document.getElementById('closeVerifyButton');

    var phoneNumber;
    var codeSent = false;

    $("#verifyForm").submit(() => { return false; });

    function setUpPhoneVerify(phone) {
        phoneNumber = phone;
        verifyPhoneTextField.value = formatPhone(phone);
        if (initialoffer != null) {
            verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFF ONE ORDER';
        }
        if (referralid != null) {
			verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFFER FROM YOUR FRIEND';
        }
        verifyModal.style.display = 'flex';
    }

    resendCodeButton.addEventListener('click', async () => {
        resetView();
    });

    verifySmsButton.addEventListener('click', async () => {
        if (codeSent === false) {
            phoneNumber = verifyPhoneTextField.value.replace(/\D/g, '');
            var error = '';
            if (phoneNumber.length != 10) {
                error = 'Please enter full 10 digits';
            }
            if (error != '') {
                alert(error);
            } else {
                checkPhoneNumber(phoneNumber);
            }
        } else {
            // verify with code
            const code = verifyPhoneTextField.value;
            var error = '';
            if (code.length != 6) {
                error = 'Please enter 6 digit code sent in SMS';
            }
            if (error != '') {
                alert(error);
            } else {
                verifyPhoneNumber(phoneNumber, code);
            }
        }
    });

    closeVerifyButton.addEventListener('click', async () => {
        verifyModal.style.display = 'none';
        goToNextPage('/profile');
    });

    async function verifyPhoneNumber(phone, code) {
        progressModal.style.display = 'flex';
        try {
            const status = await Parse.Cloud.run('verifyTextCodeWeb', {'phone':phone, 'code': code});
            if (status === 'approved') {
                const request = {'phone': phoneNumber, 'initialamount': initialamount, 'referid': referralid, 'locationid': locationId};
                await Parse.Cloud.run('updateUserVerificationAndRefferal', request);

                const currentUser = Parse.User.current();
                if (currentUser != null) {
                    await currentUser.fetch();
                }

                goToNextPage('/profile');
            } else {
                alert('Code failed please try again');
            }
        } catch(e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    
    async function checkPhoneNumber(phone) {
        progressModal.style.display = 'flex';
        try {
            const available = await Parse.Cloud.run('checkPhoneNumber', {"phone":phone});
            if (available == true) {
                await sendCode(phone);
            } else {
                alert('Offer already redeemed by this phone number');
            }
        } catch(e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    
    async function sendCode(phone) {
        const status = await Parse.Cloud.run('sendTextVerificationWeb', {"phone":phone});
        if (status === "pending") {
            verifyPhoneTextField.value = '';
            verifyPhoneTextField.placeholder = 'Enter Code';
            verifyTopLabel.innerText = 'ENTER 6 DIGIT CODE'
            resendCodeButton.style.display = 'block';
            verifySmsButton.value = 'VERIFY';
            verifyPhoneTextField.focus();
            codeSent = true;
        } else {
            alert('Code failed to send');
        }
    }
    
    async function resetView() {
        verifyPhoneTextField.value = formatPhone(phoneNumber);
        verifyTopLabel.innerText = 'TO RECEIVE THIS OFFER YOU MUST VERIY PHONE NUMBER VIA SMS';
        resendCodeButton.style.display = 'none';
        verifySmsButton.value = 'SEND SMS CODE';
        codeSent = false;
        
        if (initialoffer != null) {
            verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFF ONE ORDER';
        }
        if (referralid != null) {
			verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFFER FROM YOUR FRIEND';
        }
    }
});